// TODO : remplace par l'URL réelle
export const PAUL_LUNEAU_URL = "https://www.instagram.com/pauluneau/";
export const LOU_CHEYMOL_URL = "https://www.instagram.com/l_ou.c?igsh=Nmpsb3djbGdmbW9u&fbclid=IwY2xjawTUj5hleHRuA2FlbQIxMQBzcnRjBmFwcF9pZAEwAAEeg1NNMqLzyouzH5Wm2-NBuRv57C8-q32dniMLiU0bj0lmrYQP2qsbS8d6JLk_aem_CRlmTM2JUtyqk9ckXtazaA";
export const NOAN_PETRO_VERNEAU_URL = "https://www.linkedin.com/in/noan-petro-verneau-01270b318/";
export const THIBAULT_MALBRANCHE_URL = "https://github.com/titozzz";
export const GEOFFREY_DORNE_URL = "https://hckr.fr/";

// Ajouter une constante par personne / organisation linkée :
// export const AUTRE_NOM_URL = "https://...";
